import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import {
  // SET_CURRENT_USER,
  // SET_USER_TOKEN,
  SET_HAS_MEMBERSHIP_ACCESS,
  SET_INVITE_CODES,
  SET_HIDE_UPGRADE_WALL,
  SET_PRESET_COUPON_CODE,
} from "./mutationTypes";

import account from './modules/account'
import membership from './modules/membership'
import tickets from './modules/tickets'
import membershipCoupon from './modules/membershipCoupon'
import upgradeWall from './modules/upgradeWall'

Vue.use(Vuex)



const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    // currentUser: state.currentUser,
    // userToken: state.userToken,
    hasMembershipAccess: state.hasMembershipAccess,
    presetCouponCode: state.presetCouponCode,
    inviteCodes: state.inviteCodes,
    hideUpgradeWallUntil: state.hideUpgradeWallUntil,
  }),
  filter: (mutation) => {
    return mutation.type == SET_HAS_MEMBERSHIP_ACCESS ||
      mutation.type == SET_INVITE_CODES ||
      mutation.type == SET_PRESET_COUPON_CODE ||
      mutation.type == SET_HIDE_UPGRADE_WALL
      // mutation.type == SET_CURRENT_USER ||
      //mutation.type == SET_USER_TOKEN
  }
})

const state = {
  currentUser: null,
  userToken: null,
  hasMembershipAccess: false,
  selectedMembershipType: null,
  membershipCoupon: null, // verified coupon object

  presetCouponCode: null, // coupon code passed via query parameter `coupon`
  inviteCodes: null,

  // Payment
  squareStatus: 'none',
  stripeStatus: 'none',

  //Utility properties
  message: null,
  isLoading: false,
  isError: false,
  lastError: null,

  ticketsUri: null,

  hideUpgradeWallUntil: null,

  hideActionRequired: false,

  membershipScanPending: false,
}



const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    account: account,
    membership: membership,
    tickets: tickets,
    membershipCoupon: membershipCoupon,
    upgradeWall: upgradeWall,
  },
  plugins: [vuexLocal.plugin]
})

export default store
